import { AWSAppSyncClient } from 'aws-appsync'
import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import { AUTH_TYPE } from 'aws-appsync/lib/link/auth-link'

Amplify.configure({
  Auth: {
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_REGION
  }
})

export const ApiClient = new AWSAppSyncClient({
  url: process.env.VUE_APP_GRAPHQL_ENDPOINT,
  region: process.env.VUE_APP_REGION,
  auth: {
    type: AUTH_TYPE.AWS_IAM,
    credentials: () => Auth.currentCredentials()
  },
  disableOffline: true
})
